import { useSelector } from 'react-redux';
import { CartoLayer, MAP_TYPES } from '@deck.gl/carto';
import { selectSourceById } from '@carto/react-redux';
import { useCartoLayerProps } from '@carto/react-api';
import htmlForFeature from 'utils/htmlForFeature';

export const MHZ_POPS_LAYER_ID = 'mhzPopsLayer';

function MhzPopsLayer() {
  const { mhzPopsLayer } = useSelector((state) => state.carto.layers);
  const source = useSelector((state) => selectSourceById(state, mhzPopsLayer?.source));
  const cartoFilterProps = useCartoLayerProps({ source });

  if (mhzPopsLayer && source) {
    return new CartoLayer({
      ...cartoFilterProps,
      id: MHZ_POPS_LAYER_ID,
      type: MAP_TYPES.QUERY,
      data: source.data,
      credentials: source.credentials,
      getFillColor: [241, 109, 122],
      pointRadiusMinPixels: 2,
      pickable: true,
      onHover: (info) => {
        if (info?.object) {
          info.object = {
            html: htmlForFeature(info.object),
            style: {},
          };
        }
      },
    });
  }
}

export default MhzPopsLayer;
